import { Step, StepButton, StepLabel, Stepper, Typography } from '@mui/material';
import { SendStep, SubmissionDraft, isStepValid } from '../submission-send-rules';

const STEPS = [
    { step: SendStep.Data, label: 'Dados' },
    { step: SendStep.Files, label: 'Arquivos' },
    { step: SendStep.Vehicles, label: 'Veículos' },
    { step: SendStep.Review, label: 'Revisão' },
];

function caption(step: SendStep, draft: SubmissionDraft): string | undefined {
    if (step === SendStep.Files && draft.files.length) return draft.files.length === 1 ? '1 arquivo' : `${draft.files.length} arquivos`;
    if (step === SendStep.Vehicles && draft.vehicleIds.length) return draft.vehicleIds.length === 1 ? '1 veículo' : `${draft.vehicleIds.length} veículos`;
    return undefined;
}

export function SendStepper({ draft, activeStep, reached, showErrors, onStep }: {
    draft: SubmissionDraft; activeStep: SendStep; reached: SendStep; showErrors: boolean; onStep: (step: SendStep) => void;
}) {
    return (
        <Stepper nonLinear activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
            {STEPS.map(({ step, label }) => {
                const valid = isStepValid(draft, step);
                const completed = step !== SendStep.Review && step < activeStep && valid;
                const error = !valid && ((step <= reached && step !== activeStep) || (showErrors && step === activeStep));
                const text = caption(step, draft);
                return (
                    <Step key={step} completed={completed}>
                        <StepButton onClick={() => onStep(step)} optional={text && <Typography variant="caption" color="text.secondary" component="div" textAlign="center">{text}</Typography>}>
                            <StepLabel error={error} sx={{ '& .MuiStepLabel-label': { fontWeight: step === activeStep ? 700 : 500 } }}>{label}</StepLabel>
                        </StepButton>
                    </Step>
                );
            })}
        </Stepper>
    );
}
